export default "__VITE_ASSET__64c82f48__"